import React, { useEffect, useState } from "react";
import {
  ButtonToggle,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import {
  LOOKUP_BY_NUMBER_URL,
  STATE_LIST,
  UPLOAD_FILE,
} from "../../constants/ApiPaths";
import API from "../../redux/actions/API";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import moment from "moment";

import CustomButtonLoader from "../CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../../functions/CustomFunctions";
import dogImg from "../../images/dog.png";

export default function UserInformation(props) {
  const {
    handleBlur,
    touched,
    handleChange,
    errors,
    values,
    setValues,
    setCustomerId,
    setFutureFlag,
  } = props;
  const [stateList, setStateList] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [errors, setErrors] = useState({});
  // const {
  //   firstName,
  //   lastName,
  //   email,
  //   password,
  //   gender,
  //   dateOfBirth,
  //   phoneNumber,
  //   profileImage,
  //   stateId,
  //   city,
  //   address,
  //   zip,
  //   agencyUrl,
  //   dogName,
  //   breed,
  //   color,
  //   DOB,
  //   sex,
  //   dogImageUrl,
  //   dogDescription,
  // } = ApplicationForm;
  const { enqueueSnackbar } = useSnackbar();
  const fetchStateList = async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      // headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { data } = response.data;
        setStateList(data);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchStateList();
  }, []);
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        const num = v1.replace(/\D+/g, "");
        const check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        const Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });

  const lookUpFun = async () => {
    if (values.phoneNumber !== "") {
      const value = values.phoneNumber;
      let v1 = value;

      if (value) {
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }
      }
      const num = v1?.replace(/\D+/g, "");
      const check = v1?.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
      const Pass = num.length <= 10;
      if (check && Pass) {
        setLoading(true);
        const config = {
          method: "GET",
          url: LOOKUP_BY_NUMBER_URL,
          params: {
            phoneNumber: values.phoneNumber.includes("+1")
              ? values.phoneNumber.split("+1 ")[1]
              : values.phoneNumber,
          },
        };
        try {
          const response = await API(config);
          const {  phoneNumber, customerDetails } =
            response.data.data[0];

          const customerDetails1 = JSON.parse(customerDetails);

          // Extract values from the object
          const {
            firstName,
            lastName,
            email,
            userId,
            gender,
            dateOfBirth,
            stateId,
            city,
            address,
            zip,
            dogName,
            breed,
            color,
            DOB,
            sex,
            dogImageUrl,
            dogDescription,
          } = customerDetails1;
          setCustomerId(userId);
          // Use the values as needed, for example, setValues
          setValues({
            firstName,
            lastName,
            email,
            usphoneNumber: "+1 ".concat(phoneNumber),
            gender,
            dateOfBirth,
            stateId,
            city,
            address,
            zip,
            dogName,
            breed,
            color,
            DOB,
            sex,
            dogImageUrl,
            dogDescription,
          });
        } catch (error) {
          if (error) {
            // const {  message } = error.response.data;
            CustomAlertMessage('Error', "error", enqueueSnackbar);
          }
          console.error(error);
        } finally {
          setLoading(false);
        }
      } else {
        CustomAlertMessage(
          "Enter valid phone number",
          "error",
          enqueueSnackbar
        );
      }
    } else {
      CustomAlertMessage("Please enter phone number", "error", enqueueSnackbar);
    }
  };

  const handleSave = async (e) => {
    if (e.target.checked === true) {
      setFutureFlag(true);
    }
  };
    const choosenImage = async (event) => {
      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
      setLoading(true);
      const file = new FormData();
      file.append("file", event.target.files[0]);
      if (!event.target.files[0]) return;
      if (event.target.files[0]?.size > MAX_FILE_SIZE) {
        // errors.petProfileImage = "Image size must be less than 5 MB";
         CustomAlertMessage('Image size must be less than 5 MB', "error", enqueueSnackbar);
          return;
      }
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: file,
        "content-type": "multipart/form-data",
      };
  
      try {
        const response = await API(config);
        const { filePath, status } = response.data;
        if (status === "Success") {
          setValues({
            ...values,
            dogImageUrl: filePath,
          });
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        const { data } = error.response;
  
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      } finally {
        setLoading(false);
      }
    };
  return (
    <>
      <Row form>
        <Col md={6}>
          <FormGroup>
            <Label for="phoneNumber" className="high-user-text">
              Phone Number
            </Label>
            <InputGroup>
              <Input
                type="text"
                name="phoneNumber"
                id="phoneNumber"
                value={values.phoneNumber}
                placeholder="Enter Phone Number"
                invalid={
                  errors.phoneNumber && touched.phoneNumber ? true : false
                }
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.phoneNumber && touched.phoneNumber
                  ? errors.phoneNumber
                  : ""}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col md={6}>
          <ButtonToggle
            style={{ marginTop: "30px" }}
            // form={`endUserWebForm_${currentStep}`}
            // type="submit"
            color="primary"
            onClick={lookUpFun}
          >
            {loading && <CustomButtonLoader loading={loading} />}

            {"Look Up"}
          </ButtonToggle>
        </Col>
        <Col md={6}>
          <Label for="" className="high-user-text">
            Personal Info
          </Label>
        </Col>
        <Col md={6}></Col>
        <Col md={6}>
          <FormGroup>
            <Label for="firstName">First Name *</Label>
            <Input
              type="text"
              name="firstName"
              id="firstName"
              placeholder="Enter First Name"
              onChange={handleChange}
              value={values.firstName}
              invalid={errors.firstName && touched.firstName ? true : false}
            />
            <FormFeedback>
              {errors.firstName && touched.firstName && "Enter First Name"}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="lastName">Last Name *</Label>
            <InputGroup>
              <Input
                type="text"
                name="lastName"
                id="lastName"
                value={values.lastName}
                placeholder="Enter Last Name"
                invalid={errors.lastName && touched.lastName ? true : false}
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.lastName && touched.lastName ? errors.lastName : ""}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="email">Email *</Label>
            <InputGroup>
              <Input
                type="text"
                name="email"
                id="email"
                value={values.email}
                placeholder="Enter Email"
                invalid={errors.email && touched.email ? true : false}
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.email && touched.email ? errors.email : ""}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="">Date of Birth</Label>
            <Input
              type="date"
              name="dateOfBirth"
              value={moment(values.dateOfBirth).format("YYYY-MM-DD")}
              onBlur={handleBlur}
              invalid={errors.dateOfBirth && touched.dateOfBirth ? true : false}
              onChange={handleChange}
              placeholder="Date of Birth"
              id=""
            />
            <FormFeedback>
              {errors.dateOfBirth && touched.dateOfBirth
                ? errors.dateOfBirth
                : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="">Gender</Label>
            <Input
              type="select"
              name="gender"
              value={values.gender}
              onBlur={handleBlur}
              invalid={errors.gender && touched.gender ? true : false}
              onChange={handleChange}
              id=""
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </Input>
            <FormFeedback>
              {errors.gender && touched.gender ? errors.gender : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="address">Address</Label>
            <Input
              className="txtare-hih"
              type="textarea"
              name="address"
              id="address"
              value={values.address}
              onBlur={handleBlur}
              onChange={handleChange}
              invalid={touched.address && errors.address ? true : false}
              placeholder="Address"
            />
            <FormFeedback>
              {touched.address && errors.address ? errors.address : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="city">City</Label>
            <Input
              type="text"
              name="city"
              id="city"
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={touched.city && errors.city ? true : false}
              placeholder="City"
            />
            <FormFeedback>
              {touched.city && errors.city ? errors.city : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="state">State</Label>
            <Input
              type="select"
              name="stateId"
              id="state"
              value={values.stateId}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={touched.stateId && errors.stateId ? true : false}
              placeholder="State"
            >
              <option key="1" value="">
                Select State
              </option>
              ;
              {stateList.map((list) => {
                const { stateId, stateName } = list;

                return (
                  <option key={stateId} value={stateId}>
                    {stateName}
                  </option>
                );
              })}
            </Input>
            <FormFeedback>
              {touched.stateId && errors.stateId ? errors.stateId : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="zip">Zip</Label>
            <Input
              type="tel"
              name="zip"
              id="zip"
              value={values.zip}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={touched.zip && errors.zip ? true : false}
              placeholder="Zip"
            />
            <FormFeedback>
              {touched.zip && errors.zip ? errors.zip : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="phoneNumber">Phone Number</Label>
            <InputGroup>
              <Input
                type="text"
                name="usphoneNumber"
                id="usphoneNumber"
                value={values.usphoneNumber}
                placeholder="Enter Phone Number"
                invalid={
                  errors.usphoneNumber && touched.usphoneNumber ? true : false
                }
                onChange={handleChange}
              />
              <FormFeedback>
                {errors.usphoneNumber && touched.usphoneNumber
                  ? errors.usphoneNumber
                  : ""}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        </Col>
        {/* pet info */}
        <Col md={6}>
          <Label for="" className="high-user-text">
            Pet Info
          </Label>
        </Col>
        <Col md={6}></Col>
        <Col md={12}>
         <div className="user-box">
              <img
              alt=""
                value={values.dogImageUrl}
                src={values.dogImageUrl ? values.dogImageUrl : dogImg}
              />
              <p>Dog Profile</p>

              <div className="upload-btn-wrapper">
                <button className="upload-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.407"
                    height="16.981"
                    viewBox="0 0 19.407 16.981"
                  >
                    <path
                      id="Icon_awesome-camera"
                      data-name="Icon awesome-camera"
                      d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                      transform="translate(0 -2.25)"
                      fill="#d51d1d"
                    />
                  </svg>
                </button>
                <Input type="file" name="dogImageUrl" onChange={choosenImage} />
              </div>
            </div>
            </Col>
        {/* <Row xs="12"> */}
        <Col md={6}>
          <FormGroup>
            <Label for="dogName">Pet Name *</Label>
            <Input
              type="text"
              name="dogName"
              value={values.dogName}
              onBlur={handleBlur}
              invalid={errors.dogName && touched.dogName ? true : false}
              onChange={handleChange}
              id=""
              placeholder="Enter  Name"
            />
            <FormFeedback>
              {errors.dogName && touched.dogName ? errors.dogName : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="color">Color *</Label>
            <Input
              type="text"
              name="color"
              value={values.color}
              onBlur={handleBlur}
              invalid={errors.color && touched.color ? true : false}
              onChange={handleChange}
              id="color"
              placeholder="Enter Color"
            />
            <FormFeedback>
              {errors.color && touched.color ? errors.color : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="sex">Gender *</Label>
            <Input
              type="select"
              name="sex"
              value={values.sex}
              onBlur={handleBlur}
              invalid={errors.sex && touched.sex ? true : false}
              onChange={handleChange}
              id="sex"
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </Input>
            <FormFeedback>
              {errors.sex && touched.sex ? errors.sex : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="breed">Breed *</Label>
            <Input
              type="text"
              name="breed"
              value={values.breed}
              onBlur={handleBlur}
              invalid={errors.breed && touched.breed ? true : false}
              onChange={handleChange}
              id="breed"
              placeholder="Enter Breed"
            />
            <FormFeedback>
              {errors.breed && touched.breed ? errors.breed : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="DOB">Date of Birth</Label>
            <Input
              type="date"
              name="DOB"
              value={moment(values.DOB).format("YYYY-MM-DD")}
              onBlur={handleBlur}
              invalid={errors.DOB && touched.DOB ? true : false}
              onChange={handleChange}
              placeholder="Date of Birth"
              id="DOB"
            />
            <FormFeedback>
              {errors.DOB && touched.DOB ? errors.DOB : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="dogDescription">Description *</Label>
            <Input
              type="text"
              name="dogDescription"
              value={values.dogDescription}
              onBlur={handleBlur}
              invalid={
                errors.dogDescription && touched.dogDescription ? true : false
              }
              onChange={handleChange}
              id="dogDescription"
              placeholder="Enter Description"
            />
            <FormFeedback>
              {errors.dogDescription && touched.dogDescription
                ? errors.dogDescription
                : ""}
            </FormFeedback>
          </FormGroup>
        </Col>
        <Col md={12}>
          <FormGroup check>
            <Label check>
              <Input
                onChange={handleSave}
                // value={value}
                onBlur={handleBlur}
                type="checkbox"
                // name={uniqueId}
              />{" "}
              Do you want to save this information for future use?
            </Label>
          </FormGroup>
        </Col>
        {/* </Row> */}
      </Row>
    </>
  );
}
